//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ParentContactDisplayItem } from './ParentContactDisplayItem';

export class StudentContactDisplayItem extends ItemBase {
    ID: string | null = null;
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    MobilePhone: string | null = null;
    FullName: string | null = null;
    ProfileThumbnailURL: string | null = null;
    ParentContacts: ParentContactDisplayItem[] = [];

    constructor(initializer?: Partial<StudentContactDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StudentContactDisplayItem";
}
